import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import { useGlobalState } from "../../../services/hostelConst.js";
import {
  getHostelApplicationList,
  rejectHostelApplication,
  acceptHostelApplication,
} from "../../../services/OrganisationServices/hostelManagmentService";
import AddHostelApplicationComponent from "./submit-hostel-application-form";
const OpenHostelApplicationTable = () => {
  var { id } = useParams();

  const { updateAdvanceFilterList } = useGlobalState();
  useEffect(() => {
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
      };
    });

    return () => {};
  }, []);

  return (
    <div>
      <MasterTable
        getTableData={getHostelApplicationList}
        tab1={"Hostel"}
        tab2={"Open"}
        hostelId={id}
        externalPermis={{
          POST: 1,
          GET: 1,
          PUT: 1,
          DELETE: 1,
          PATCH: 0,
        }}
        acceptMethod={acceptHostelApplication}
        rejectMethod={rejectHostelApplication}
        actions={{
          accept: true,
          reject: true,
        }}
        AddForm={AddHostelApplicationComponent}
      />
    </div>
  );
};

export default OpenHostelApplicationTable;
